import { QueryCache } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

export const useGlobalQueryErrorHandler = (openNotification: any) => {
  const location = useLocation();
  const errorShownRef = useRef(false);

  useEffect(() => {
    errorShownRef.current = false;
  }, [location.pathname]);

  const queryCache = new QueryCache({
    onError: (error, query) => {
      const isFirstFetch =
        !query.state.dataUpdatedAt || query.state.fetchStatus === "fetching";

      if (isFirstFetch && !errorShownRef.current && openNotification) {
        errorShownRef.current = true;
        // if (error) {
        //   const errorObj = error && JSON.stringify(error) ? JSON.parse(JSON.stringify(error)) : null;
        //   const isAuthError = errorObj?.status !== 401;
        //   if (isAuthError) {
        //     openNotification({
        //       key: "server_error",
        //       type: "error",
        //       message: "Something went wrong!",
        //     });
        //   }
        // }
      }
    },
  });

  return queryCache;
};
